"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _constant = require("../constant");

var _calendar = require("../calendar.utilities");

var _calendarInstance = _interopRequireDefault(require("./calendarInstance.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable consistent-return */


var weekDaysNames = _constant.WEEK_NAME;
var calendarItemActive = (0, _styledComponents.css)(["background-color:#4b4fa6;border-radius:55/2;"]);
var disableButton = (0, _styledComponents.css)(["cursor:not-allowed;"]);
var calendarTextActive = (0, _styledComponents.css)(["color:white;"]);
var disableCalendarItem = (0, _styledComponents.css)(["color:#e2e2e2;cursor:not-allowed;"]);

var CalendarHeaderContainer = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__CalendarHeaderContainer",
  componentId: "sc-2qasqf-0"
})(["font-family:", ";display:flex;flex-direction:row;justify-content:center;align-items:center;flex:1;padding:15px 0;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily.default;
});

var CalendarNavButton = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__CalendarNavButton",
  componentId: "sc-2qasqf-1"
})(["cursor:", ";color:", ";"], function (props) {
  return props.disableprevbutton ? 'not-allowed' : 'pointer';
}, function (_ref2) {
  var isOnlyApplyForHotel = _ref2.isOnlyApplyForHotel,
      theme = _ref2.theme;
  return isOnlyApplyForHotel ? theme.colors.greyDark : theme.colors.darkBlack;
});

var CalendarHeaderItem = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__CalendarHeaderItem",
  componentId: "sc-2qasqf-2"
})(["flex:1;font-size:16px;color:#212124;font-weight:500;text-align:center;"]);

var MidleContainer = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__MidleContainer",
  componentId: "sc-2qasqf-3"
})(["flex-grow:2;display:flex;justify-content:center;align-items:baseline;"]);

var Week = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__Week",
  componentId: "sc-2qasqf-4"
})(["display:flex;margin-bottom:", ";flex-direction:row;justify-content:center;align-items:center;margin-bottom:1px;"], function (props) {
  return props.daynames && '15px';
});

var WeekDay = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__WeekDay",
  componentId: "sc-2qasqf-5"
})(["font-family:", ";display:flex;flex:1;text-align:center;padding-bottom:3px;color:black;width:48px;align-items:center;justify-content:center;cursor:pointer;font-size:", ";color:", ";font-weight:400;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize.small;
}, function (_ref5) {
  var isOnlyApplyForHotel = _ref5.isOnlyApplyForHotel,
      theme = _ref5.theme;
  return isOnlyApplyForHotel ? theme.colors.greyDark : '#1d1d1d';
});

var DayButton = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__DayButton",
  componentId: "sc-2qasqf-6"
})(["font-family:", ";position:relative;display:flex;background-color:transparent;flex:1;width:48px;height:48px;align-items:center;justify-content:center;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily.default;
});

var Hovernav = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__Hovernav",
  componentId: "sc-2qasqf-7"
})(function (_ref7) {
  var theme = _ref7.theme;
  return "\n    & .hovered{\n      background: ".concat(theme.colors.secondaryLight, ";\n    }\n\n    & .hoveredDate{\n      background: ").concat(theme.colors.secondaryBlue, ";\n      border-top-right-radius: ").concat(theme.borderRadius.normal, ";\n      border-bottom-right-radius: ").concat(theme.borderRadius.normal, ";\n\n      &.week-start{\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n      }\n\n      & div {\n        color: ").concat(theme.colors.default, ";\n      }\n    }\n  ");
});

var CalendarItemContainer = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__CalendarItemContainer",
  componentId: "sc-2qasqf-8"
})(function (_ref8) {
  var theme = _ref8.theme,
      roundCornerLeft = _ref8.roundCornerLeft,
      roundCornerRight = _ref8.roundCornerRight;
  return "\n    ".concat(roundCornerLeft ? "\n            border-top-left-radius: ".concat(theme.borderRadius.normal, ";\n            border-bottom-left-radius: ").concat(theme.borderRadius.normal, ";\n          ") : '', "\n\n    ").concat(roundCornerRight ? "\n          border-top-right-radius: ".concat(theme.borderRadius.normal, ";\n          border-bottom-right-radius: ").concat(theme.borderRadius.normal, ";\n          ") : '', "\n  ");
});

var CalendarItem = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__CalendarItem",
  componentId: "sc-2qasqf-9"
})(function (_ref9) {
  var theme = _ref9.theme,
      selectedtwo = _ref9.selectedtwo,
      selectedthree = _ref9.selectedthree,
      roundCornerLeft = _ref9.roundCornerLeft,
      roundCornerRight = _ref9.roundCornerRight,
      roundCornerAll = _ref9.roundCornerAll;
  return "\n    flex: 1;\n    display: flex;\n    text-align: center;\n    margin-bottom: 3px;\n    color: black;\n    width: 48px;\n    height: 48px;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    position: relative;\n    z-index: 2;\n    ".concat(selectedtwo ? calendarItemActive : '', "\n    ").concat(selectedthree ? disableButton : '', "\n    ").concat(roundCornerLeft ? "\n          border-top-left-radius: ".concat(theme.borderRadius.normal, ";\n          border-bottom-left-radius: ").concat(theme.borderRadius.normal, ";\n          ") : '', "\n\n    ").concat(roundCornerRight ? "\n          border-top-right-radius: ".concat(theme.borderRadius.normal, ";\n          border-bottom-right-radius: ").concat(theme.borderRadius.normal, ";\n          ") : '', "\n\n    ").concat(roundCornerAll ? "\n          border-radius: ".concat(theme.borderRadius.normal, ";\n          ") : '', "\n  ");
});

var DayStyling = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__DayStyling",
  componentId: "sc-2qasqf-10"
})(function (_ref10) {
  var selectedtwo = _ref10.selectedtwo,
      selectedthree = _ref10.selectedthree,
      theme = _ref10.theme;
  return "\n    font-size: ".concat(theme.fontSize.small, ";\n    color: #1d1d1d;\n    font-weight: ").concat(theme.fontWeight.normal, ";\n    overflow: hidden;\n    padding: 0 ").concat(theme.space.micro, ";\n    ").concat(selectedtwo && calendarTextActive, ";\n    ").concat(selectedthree && disableCalendarItem, ";\n  ");
});

var PriceStyling = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__PriceStyling",
  componentId: "sc-2qasqf-11"
})(function (_ref11) {
  var truncateText = _ref11.truncateText,
      theme = _ref11.theme;
  return "\n    font-size: ".concat(theme.fontSize.XSmall, ";\n\n    ").concat(truncateText ? "\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          width: 100%;\n          " : '', "\n  ");
});

var ChevonIconStyle = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "calendarInstance__ChevonIconStyle",
  componentId: "sc-2qasqf-12"
})(["color:", ";"], function (_ref12) {
  var isOnlyApplyForHotel = _ref12.isOnlyApplyForHotel,
      theme = _ref12.theme;
  return isOnlyApplyForHotel ? theme.colors.greyDark : theme.colors.darkBlack;
});

var LefticonContainer = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__LefticonContainer",
  componentId: "sc-2qasqf-13"
})([""]);

var RighticonContainer = _styledComponents.default.div.withConfig({
  displayName: "calendarInstance__RighticonContainer",
  componentId: "sc-2qasqf-14"
})([""]);

var AaCalendarInstance = function AaCalendarInstance(props) {
  var controls = props.controls,
      data = props.data,
      theme = props.theme,
      isFlight = props.isFlight,
      lfcPrices = props.lfcPrices,
      exchangeRate = props.exchangeRate,
      isOnlyApplyForHotel = props.isOnlyApplyForHotel,
      isSnapCalendar = props.isSnapCalendar,
      snapLfcPrices = props.snapLfcPrices,
      isPartialHotelCalendar = props.isPartialHotelCalendar,
      flightDepart = props.flightDepart,
      flightReturn = props.flightReturn,
      minNights = props.minNights,
      enableAvailableDateCalendarFlag = props.enableAvailableDateCalendarFlag;
  var customDateLabels = controls.customDateLabels;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var today = new Date();
  var itemsRef = (0, _react.useRef)([]);
  /**
   * Assign AaCalendarUtilities method to local variable
   * to avoid repeating calls of AaCalendarUtilities
   */

  var checkIfDateIsPreviousOfStartDate = _calendar.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate;
  var checkIfDateIsPreviousOrEqualOfStartDate = _calendar.AaCalendarUtilities.checkIfDateIsPreviousOrEqualOfStartDate;
  var checkIfDateAreSame = _calendar.AaCalendarUtilities.checkIfDateAreSame;
  var checkIfDateIsAheadOfStartDate = _calendar.AaCalendarUtilities.checkIfDateIsAheadOfStartDate;
  var subtractDaysToDate = _calendar.AaCalendarUtilities.subtractDaysToDate;
  var addDaysToDate = _calendar.AaCalendarUtilities.addDaysToDate;
  var maxDate = null;
  var blanks = [];
  var days = [];
  var dateObj;

  if (controls.maxDate) {
    maxDate = new Date(controls.maxDate);
  }

  if (controls && controls.year && controls.month !== null) {
    dateObj = new Date(controls.year, controls.month);
  }

  (0, _react.useEffect)(function () {
    itemsRef.current = Array(controls.maxDays).fill().map(function (_, i) {
      return itemsRef.current[i] || /*#__PURE__*/(0, _react.createRef)();
    });
  }, [controls.maxDays]);
  /**
   *
   * @param {Date} startDate - start date object
   * @param {Date} endDate - end date object
   *
   * Remove backgroundColor style from `startDate` to `endDate`
   */

  var resetHoverDates = function resetHoverDates(startDate, endDate) {
    if (!startDate || !endDate) {
      return;
    }

    var newDate = endDate;

    var daysDiff = _calendar.AaCalendarUtilities.dayDifference(startDate, endDate);

    if (daysDiff < 0 || Number.isNaN(daysDiff)) {
      // eslint-disable-next-line consistent-return
      return false;
    } // eslint-disable-next-line no-lone-blocks


    {
      for (var i = 0; i <= daysDiff; i += 1) {
        var id = isPartialHotelCalendar ? "partialHotelDiv-".concat(newDate.getFullYear(), "-").concat(newDate.getMonth(), "-").concat(newDate.getDate()) : "div-".concat(newDate.getFullYear(), "-").concat(newDate.getMonth(), "-").concat(newDate.getDate());
        var e = document.getElementById(id);
        newDate = _calendar.AaCalendarUtilities.subtractDaysToDate(newDate, 1);

        if (e) {
          e.classList.remove('hovered');
          e.classList.remove('hoveredDate');
        }
      }
    }
  };
  /**
   * Removes all highlighted dates when user press `Reset` button
   */


  (0, _react.useEffect)(function () {
    if (!controls.resetData) {
      return;
    }

    resetHoverDates(new Date(data.departDate.year, data.departDate.month, data.departDate.date), new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date));
  }, [controls.resetData, data.departDate.date, data.departDate.month, data.departDate.year, data.returnDate.date, data.returnDate.month, data.returnDate.year]);

  var _useState = (0, _react.useState)("".concat(_constant.MONTH_NAMES[dateObj.getMonth()], " ").concat(dateObj.getFullYear())),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      calendarLabel = _useState2[0],
      setCalendarLabel = _useState2[1];

  var _useState3 = (0, _react.useState)(_constant.MONTH_NAMES[dateObj.getMonth()]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      monthLabel = _useState4[0],
      setMonthLabel = _useState4[1];

  var _useState5 = (0, _react.useState)(dateObj.getFullYear()),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      yearLabel = _useState6[0],
      setYearLabel = _useState6[1];

  var setMonthAndYearLabel = function setMonthAndYearLabel(dateData) {
    setMonthLabel(_constant.MONTH_NAMES[dateData.getMonth()]);
    setYearLabel(dateData.getFullYear());
  };
  /**
   *
   * @param {number} month - month in number
   * @param {number} year - year in number
   *
   * Returns how many days are there in a month
   */


  var getDaysInMonth = function getDaysInMonth(month, year) {
    return new Date(year, month + 1, 0).getDate();
  };
  /**
   *
   * @param {number} month - month in number
   * @param {number} year - year in number
   *
   * Returns the index of a day
   */


  var getWeekDayIndex = function getWeekDayIndex(month, year) {
    return new Date(year, month).getDay();
  };

  var daysOfCurrentMonth = getDaysInMonth(dateObj.getMonth(), dateObj.getFullYear());
  var dayStart = getWeekDayIndex(dateObj.getMonth(), dateObj.getFullYear());

  var createBlanks = function createBlanks() {
    for (var i = 0; i < dayStart; i += 1) {
      blanks.push(' ');
    }
  };

  var getPrice = function getPrice(day) {
    if (!day || Number.isNaN(day) || customDateLabels) {
      return;
    }

    var formattedDate = _calendar.AaCalendarUtilities.datePayloadFormat(new Date(dateObj.getFullYear(), dateObj.getMonth(), day));

    if (isSnapCalendar) {
      if (snapLfcPrices) {
        var price = snapLfcPrices[formattedDate];

        if (!price) {
          return;
        }

        return price;
      }

      return null;
    }

    if (!lfcPrices) {
      return;
    }

    if (!lfcPrices.oneway) {
      return;
    } // eslint-disable-next-line consistent-return
    // return price;


    if (controls.selectForDepart && !data.returnDate.date) {
      var _price = props.lfcPrices.oneway[formattedDate];

      if (!_price) {
        return;
      }

      return _calendar.AaCalendarUtilities.exchangeRateConverter(_price, exchangeRate); // return AaCalendarUtilities.currencyFormatter(price, 2);
    }

    if (lfcPrices.oneway && controls.selectForReturn && lfcPrices && lfcPrices.return || data.departDate.date && data.returnDate.date) {
      var priceOneWay = 0;
      var priceReturn = 0;

      if (lfcPrices.oneway) {
        priceOneWay = lfcPrices.oneway[formattedDate];
      }

      if (lfcPrices.return) {
        priceReturn = lfcPrices.return[formattedDate];
      }

      if (priceOneWay === 0 && priceReturn === 0) {
        return;
      }

      var departPrice = _calendar.AaCalendarUtilities.exchangeRateConverter(controls.departPrice, exchangeRate);

      var returnPrice = _calendar.AaCalendarUtilities.exchangeRateConverter(priceReturn, exchangeRate);

      var totalPrice = departPrice + returnPrice;

      if (Number.isNaN(totalPrice) && controls.onDateHover) {
        controls.onDateHover(null);
      }

      return totalPrice; // return  AaCalendarUtilities.currencyFormatter(totalPrice, 2)
    }

    return '';
  };

  var getSubLabel = function getSubLabel(day) {
    if (!customDateLabels) {
      return;
    }

    var formattedDate = _calendar.AaCalendarUtilities.datePayloadFormat(new Date(dateObj.getFullYear(), dateObj.getMonth(), day));

    var label = customDateLabels[formattedDate] || '';
    return label;
  };

  var createDays = function createDays() {
    for (var i = 1; i <= daysOfCurrentMonth; i += 1) {
      days.push({
        label: i,
        price: getPrice(i),
        subLabel: getSubLabel(i),
        isWeekStart: false,
        isWeekEnd: false
      });
    }
  };

  createBlanks();
  createDays();
  var totalSlots = [].concat(blanks, days);
  var rows = [];
  var cells = [];

  var createCellsRows = function createCellsRows() {
    totalSlots.forEach(function (row, i) {
      if (i % 7 !== 0) {
        cells.push(row); // if index not equal 7 that means not go to next week

        var nextIndex = i + 1;

        if (nextIndex % 7 === 0 && (0, _typeof2.default)(row) === 'object') {
          row.isWeekEnd = true;
        }
      } else {
        rows.push(cells); // when reach next week we contain all td in last week to rows

        cells = []; // empty container

        if ((0, _typeof2.default)(row) === 'object') {
          row.isWeekStart = true;
        }

        cells.push(row); // in current loop we still push current row to new container
      }

      if (i === totalSlots.length - 1) {
        // when end loop we add remain date
        rows.push(cells);
      }
    });
    var lastElementLength = rows[rows.length - 1].length;

    if (lastElementLength < 7) {
      var loopLimit = 7 - lastElementLength;

      for (var i = 1; i <= loopLimit; i += 1) {
        rows[rows.length - 1].push(' ');
      }
    }
  };

  createCellsRows();
  var weeks = rows;
  /**
   * Create new array of weekdays names when `dataFormatDate` or `dateObj` is change
   */

  (0, _react.useEffect)(function () {
    setCalendarLabel(_calendar.AaCalendarUtilities.setNoDayFormat(dateObj));
    setMonthAndYearLabel(dateObj);
    var day = controls.dataFormatDate.letterDaysTranslation; // const day = { wed: 'W', sun: 'S', fri: 'F', tue: 'T', mon: 'M', thu: 'T', sat: 'S' };

    weekDaysNames = [day.sun, day.mon, day.tue, day.wed, day.thu, day.fri, day.sat];
  }, [controls.dataFormatDate, dateObj]);
  var onHoverDates = (0, _react.useCallback)(function (startDate, endDate) {
    if (controls.selectionType === _constant.CALENDAR_SELECTION_TYPE.ONE) {
      return;
    }

    var newDate = startDate;

    var daysDiff = _calendar.AaCalendarUtilities.dayDifference(startDate, endDate);

    if (daysDiff < 0 || Number.isNaN(daysDiff)) {
      // eslint-disable-next-line consistent-return
      return false;
    }

    for (var i = 0; i <= daysDiff - 1; i += 1) {
      // eslint-disable-next-line no-lone-blocks
      {
        var id = isPartialHotelCalendar ? "partialHotelDiv-".concat(newDate.getFullYear(), "-").concat(newDate.getMonth(), "-").concat(newDate.getDate()) : "div-".concat(newDate.getFullYear(), "-").concat(newDate.getMonth(), "-").concat(newDate.getDate());
        var e = document.getElementById(id);
        newDate = _calendar.AaCalendarUtilities.addDaysToDate(newDate, 1); // if (!e) {
        //   continue;
        // }

        if (e) {
          e.classList.remove('hoveredDate');
          e.classList.add('hovered');
        }
      }
    }
  }, [controls.selectionType]);
  /**
   * Removes all highlighted dates when user pass a new data
   */

  (0, _react.useEffect)(function () {
    // resets first day to last day of the month for this calendar instance
    resetHoverDates(dateObj, new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0));
    onHoverDates(new Date(data.departDate.year, data.departDate.month, data.departDate.date), new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date));
  }, [dateObj, data, onHoverDates]);

  var isFlightNotAvailable = function isFlightNotAvailable(day) {
    if (!day || Number.isNaN(day) || !lfcPrices) {
      return false;
    }

    var formattedDate = _calendar.AaCalendarUtilities.datePayloadFormat(new Date(dateObj.getFullYear(), dateObj.getMonth(), day)); // check if we dont have data to do the grey out


    if (controls.selectForDepart && !lfcPrices.oneway || controls.selectForReturn && !lfcPrices.return) {
      return false;
    }

    var departDatesAvailable = lfcPrices.oneway ? Object.keys(lfcPrices.oneway) : [];
    var returnDatesAvailable = lfcPrices.return ? Object.keys(lfcPrices.return) : []; // if depart date is selected then do grey out for one way data

    if (controls.selectForDepart) {
      if (departDatesAvailable.length > 0 && _calendar.AaCalendarUtilities.checkifDateBeyondRange(new Date(dateObj.getFullYear(), dateObj.getMonth(), day), subtractDaysToDate(new Date(), 1), addDaysToDate(new Date(departDatesAvailable[departDatesAvailable.length - 1]), 1))) {
        return false;
      }

      if (lfcPrices.oneway && lfcPrices.oneway[formattedDate]) {
        return false;
      }

      return true;
    } // if return date selected then do grey out for return data


    if (controls.selectForReturn || data.departDate.date && data.returnDate.date) {
      if (returnDatesAvailable.length > 0 && _calendar.AaCalendarUtilities.checkifDateBeyondRange(new Date(dateObj.getFullYear(), dateObj.getMonth(), day), subtractDaysToDate(new Date(), 1), addDaysToDate(new Date(returnDatesAvailable[returnDatesAvailable.length - 1]), 1))) {
        return false;
      }

      if (lfcPrices.return && lfcPrices.return[formattedDate]) {
        return false;
      }

      return true;
    } // in all other cases show flight as available


    return false;
  };
  /**
   *
   * @param {{label: string, price: number}} d  - object from selected date
   *
   * Handles actions needed when user selects a date
   */


  var dayPress = function dayPress(d) {
    var dateTemp = new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label);

    var formattedDate = _calendar.AaCalendarUtilities.datePayloadFormat(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label));

    if (!checkIfDateIsPreviousOfStartDate(dateTemp, maxDate) || checkIfDateIsPreviousOfStartDate(dateTemp, today)) {
      return;
    }

    if (isPartialHotelCalendar && (checkIfDateIsPreviousOfStartDate(dateTemp, flightDepart) || checkIfDateIsAheadOfStartDate(dateTemp, addDaysToDate(flightReturn, 1)))) {
      return;
    }

    if (isSnapCalendar && !isPartialHotelCalendar && enableAvailableDateCalendarFlag && isFlightNotAvailable(d.label)) {
      return;
    }

    var dateToReturn = new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label);
    var price = lfcPrices && lfcPrices.oneway && lfcPrices.oneway[formattedDate] ? lfcPrices.oneway[formattedDate] : null;
    var minGap = isPartialHotelCalendar ? minNights - 1 : 0;

    if (controls.selectForDepart) {
      if (isOnlyApplyForHotel) {
        // For the Hotel, the user just can choose the depart date <= 397 from today
        var maxDepartDate = _calendar.AaCalendarUtilities.addDaysToDate(new Date(), 397);

        if (!checkIfDateIsPreviousOrEqualOfStartDate(dateToReturn, maxDepartDate)) {
          return;
        }
      }

      controls.onDepartSelected(dateToReturn, price);

      if (data.returnDate.month >= 0 && data.returnDate.date) {
        if (!isOnlyApplyForHotel) {
          setTimeout(function () {
            onHoverDates(dateTemp, new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date));
          }, 0);
        }

        if (_calendar.AaCalendarUtilities.checkIfDateIsAheadOfStartDate(addDaysToDate(dateToReturn, minGap), new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date))) {
          controls.onReturnSelected(null);
        }
      }
    } else if (controls.selectForReturn) {
      var checkDate = isSnapCalendar ? checkIfDateIsPreviousOrEqualOfStartDate : checkIfDateIsPreviousOfStartDate;

      if (checkDate(subtractDaysToDate(dateToReturn, minGap), new Date(data.departDate.year, data.departDate.month, data.departDate.date))) {
        controls.onDepartSelected(dateToReturn, price);

        if (isPartialHotelCalendar) {
          controls.onReturnSelected(null);
        }

        if (!isOnlyApplyForHotel) {
          setTimeout(function () {
            onHoverDates(dateToReturn, new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date));
          }, 0);
        }

        return;
      }

      controls.onReturnSelected(dateToReturn);

      if (!isOnlyApplyForHotel) {
        setTimeout(function () {
          onHoverDates(new Date(data.departDate.year, data.departDate.month, data.departDate.date), dateToReturn);
        }, 0);
      }
    }
  };
  /**
   *
   * @param {number} day - date number
   *
   * Checks if `day` is allowed to be hovered
   */


  var toHover = function toHover(day) {
    if (controls.selectionType === _constant.CALENDAR_SELECTION_TYPE.ONE) {
      return false;
    }

    var departSelectedDate = new Date(data.departDate.year, data.departDate.month, data.departDate.date);
    var dateOnHover = new Date(dateObj.getFullYear(), dateObj.getMonth(), day);

    var daysDiff = _calendar.AaCalendarUtilities.dayDifference(departSelectedDate, dateOnHover);

    return daysDiff > 0;
  };
  /**
   *
   * @param {Date} startDate - start date object
   * @param {Date} endDate - end date object
   *
   * Put backgroundColor style from `startDate` to `endDate`
   */
  // let check = null;


  var onHoverDay = function onHoverDay(endDate, day) {
    // if (check && check !== endDate) {
    //   const e = document.getElementById(`div-${check.getFullYear()}-${check.getMonth()}-${check.getDate()}`);
    //   // e.style.backgroundColor = 'rgba(75, 79, 166, 0.1)';
    // }
    if (controls.selectionType === _constant.CALENDAR_SELECTION_TYPE.ONE) {
      return;
    }

    var newDate = endDate;

    if (data.departDate.month && !data.returnDate.month && toHover(day)) {
      var id = isPartialHotelCalendar ? "partialHotelDiv-".concat(newDate.getFullYear(), "-").concat(newDate.getMonth(), "-").concat(newDate.getDate()) : "div-".concat(newDate.getFullYear(), "-").concat(newDate.getMonth(), "-").concat(newDate.getDate());
      var e = document.getElementById(id); // e.style.backgroundColor = '#4b4fa6';

      e.classList.add('hoveredDate'); // check = endDate;
    }
  };

  var hoverHandler = function hoverHandler(date, price, isHovered) {
    if (isHovered) {
      if (data.departDate.month && !data.returnDate.month) {
        setTimeout(function () {
          onHoverDates(new Date(data.departDate.year, data.departDate.month, data.departDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), date));
        }, 0);
      }
    }
  };

  var checkDatesToHover = function checkDatesToHover(date, price) {
    var checkdate = checkIfDateIsAheadOfStartDate(date);

    if (checkdate) {
      hoverHandler(date, price, true);
    }
  };

  var hovercheck = function hovercheck(d) {
    if (isFlight) {
      checkDatesToHover("".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label), d.price);
    } // eslint-disable-next-line no-unused-expressions


    if (data.departDate.month && !data.returnDate.month) {
      resetHoverDates(dateObj, new Date(dateObj.getFullYear(), dateObj.getMonth() + 2, 0));
      onHoverDates(new Date(data.departDate.year, data.departDate.month, data.departDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label));
    }

    onHoverDay(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), d.label);
  };
  /**
   * Hover dates whenever `departDate` and `returnDate` is change
   */


  (0, _react.useEffect)(function () {
    if (data.departDate.year && data.departDate.month >= 0 && data.departDate.date && data.returnDate.year && data.returnDate.month >= 0 && data.returnDate.date) {
      onHoverDates(new Date(data.departDate.year, data.departDate.month, data.departDate.date), new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date));
    }
  }, [onHoverDates, data.departDate, data.returnDate]);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: isPartialHotelCalendar && "partialHotelCalendar-instance-".concat(controls.month, "-").concat(controls.year) || "calendar-instance-".concat(controls.month, "-").concat(controls.year)
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(CalendarHeaderContainer, null, controls.showPrevButton && /*#__PURE__*/_react.default.createElement(LefticonContainer, {
      id: "lefticon",
      onClick: controls.onPrevButtonClicked
    }, /*#__PURE__*/_react.default.createElement(CalendarNavButton, {
      disableprevbutton: !controls.enablePrevButton
    }, /*#__PURE__*/_react.default.createElement(ChevonIconStyle, {
      fontsize: "titleNormal",
      icon: _constant.CHEVRON_LEFT_ICON,
      isOnlyApplyForHotel: isOnlyApplyForHotel
    }))), !isOnlyApplyForHotel ? /*#__PURE__*/_react.default.createElement(CalendarHeaderItem, null, calendarLabel) : /*#__PURE__*/_react.default.createElement(MidleContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      fontSize: themeContext.fontSize.normal,
      color: "neutral",
      fontWeight: themeContext.fontWeight.bold,
      textAlign: "center",
      lineHeight: themeContext.lineHeight.normal
    }, monthLabel), /*#__PURE__*/_react.default.createElement(_Text.default, {
      marginLeft: "nano",
      fontSize: themeContext.fontSize.normal,
      color: "greyDark",
      fontWeight: themeContext.fontWeight.bold,
      textAlign: "center",
      lineHeight: themeContext.lineHeight.normal
    }, yearLabel)), controls.showNextButton && /*#__PURE__*/_react.default.createElement(RighticonContainer, {
      id: "righticon",
      onClick: controls.onNextButtonClicked
    }, /*#__PURE__*/_react.default.createElement(CalendarNavButton, null, /*#__PURE__*/_react.default.createElement(ChevonIconStyle, {
      fontsize: "titleNormal",
      icon: _constant.CHEVRON_RIGHT_ICON,
      isOnlyApplyForHotel: isOnlyApplyForHotel
    })))), controls.showDaysDisplay && /*#__PURE__*/_react.default.createElement(Week, {
      daynames: true
    }, weekDaysNames.map(function (day, index) {
      return /*#__PURE__*/_react.default.createElement(WeekDay, {
        key: "".concat(controls.calendarIndex, "-").concat(_constant.WEEKDAY_KEYS[index]),
        isOnlyApplyForHotel: isOnlyApplyForHotel
      }, day);
    }))), /*#__PURE__*/_react.default.createElement("div", null, weeks.map(function (day, windex) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react.default.createElement(Week, {
          key: "Week-".concat(windex)
        }, day.map(function (d, index) {
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            _react.default.createElement("div", {
              key: "div-".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(windex, "-").concat(index, "-").concat(d)
            }, /*#__PURE__*/_react.default.createElement(DayButton, null, d.label !== ' ' ? /*#__PURE__*/_react.default.createElement(Hovernav, {
              onMouseOver: function onMouseOver() {
                return hovercheck(d);
              },
              onClick: function onClick() {
                return dayPress(d);
              },
              id: isPartialHotelCalendar && "partialHotelHovernav-".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label) || "hovernav-".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label)
            }, /*#__PURE__*/_react.default.createElement(CalendarItemContainer, {
              id: isPartialHotelCalendar && "partialHotelDiv-".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label) || "div-".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label),
              roundCornerLeft: d.isWeekStart,
              roundCornerRight: d.isWeekEnd,
              className: d.isWeekStart ? 'week-start' : ''
            }, /*#__PURE__*/_react.default.createElement(CalendarItem, {
              roundCornerAll: controls.selectionType === _constant.CALENDAR_SELECTION_TYPE.ONE || checkIfDateAreSame(new Date(data.departDate.year, data.departDate.month, data.departDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) && checkIfDateAreSame(new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)),
              roundCornerLeft: (checkIfDateAreSame(new Date(data.departDate.year, data.departDate.month, data.departDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) || d.isWeekStart) && controls.selectionType === _constant.CALENDAR_SELECTION_TYPE.TWO && !checkIfDateAreSame(new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)),
              roundCornerRight: (checkIfDateAreSame(new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) || d.isWeekEnd) && controls.selectionType === _constant.CALENDAR_SELECTION_TYPE.TWO && !checkIfDateAreSame(new Date(data.departDate.year, data.departDate.month, data.departDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)),
              selectedone: data.departDate.month && !data.returnDate.month && toHover(d.label),
              selectedtwo: checkIfDateAreSame(new Date(data.departDate.year, data.departDate.month, data.departDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) || checkIfDateAreSame(new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)),
              selectedthree: isOnlyApplyForHotel && !checkIfDateIsPreviousOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), maxDate) || !checkIfDateIsPreviousOrEqualOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), maxDate) || checkIfDateIsPreviousOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), today) || isPartialHotelCalendar && (checkIfDateIsPreviousOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), flightDepart) || checkIfDateIsAheadOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), addDaysToDate(flightReturn, 1)))
            }, /*#__PURE__*/_react.default.createElement(DayStyling, {
              selectedone: data.departDate.month && !data.returnDate.month && toHover(d.label),
              selectedtwo: checkIfDateAreSame(new Date(data.departDate.year, data.departDate.month, data.departDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) || checkIfDateAreSame(new Date(data.returnDate.year, data.returnDate.month, data.returnDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)),
              key: "".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label),
              selectedthree: !checkIfDateIsPreviousOrEqualOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), maxDate) || checkIfDateIsPreviousOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), today) || isPartialHotelCalendar && (checkIfDateIsPreviousOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), flightDepart) || checkIfDateIsAheadOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), addDaysToDate(flightReturn, 1))) || isSnapCalendar && !isPartialHotelCalendar && enableAvailableDateCalendarFlag && isFlightNotAvailable(d.label)
            }, d.label, customDateLabels ? /*#__PURE__*/_react.default.createElement(PriceStyling, {
              truncateText: true,
              title: d.subLabel
            }, d.subLabel) : /*#__PURE__*/_react.default.createElement(PriceStyling, null, isSnapCalendar || !(checkIfDateIsPreviousOrEqualOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), new Date(data.departDate.year, data.departDate.month, data.departDate.date)) && controls.selectionType === _constant.CALENDAR_SELECTION_TYPE.TWO) ? _calendar.AaCalendarUtilities.currencySymbolFormatter(d.price, controls.currency) : ' '))))) : /*#__PURE__*/_react.default.createElement(CalendarItem, {
              selectedtwo: data.departDate === d.label || data.returnDate === d.label
            }, /*#__PURE__*/_react.default.createElement("div", {
              key: "".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label)
            }, d.label))))
          );
        }))
      );
    })));
  };

  getMain.propTypes = _calendarInstance.default.PropTypes;
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

AaCalendarInstance.propTypes = _calendarInstance.default.PropTypes;
AaCalendarInstance.defaultProps = _calendarInstance.default.DefaultProps;
var _default = AaCalendarInstance;
exports.default = _default;